import { SortOrder } from "@/types/common";

import { InvoiceItem, PageSize } from "./Invoice";

export enum CreditStatus {
  Unused = "unused",
  Used = "used",
  Pending = "pending"
}

export enum CreditType {
  Credit = "credit",
  PartialCredit = "partial_credit"
}

export enum CreditSortableColumnKeys {
  CreditNo = "creditNo",
  PONumber = "poNumber",
  ShipTo = "shipTo",
  CreditDate = "creditDate",
  Total = "total",
  Status = "status"
}

export interface CreditSortableColumn {
  property: CreditSortableColumnKeys;
  direction: SortOrder;
}

export interface CreditSortableColumn {
  property: CreditSortableColumnKeys;
  direction: SortOrder;
}

export interface CreditsViewProps {
  isLoadingCredits: boolean;
  creditError: string | null;
  creditList: CreditList;
  pageSize: PageSize;
  currentPage: number;
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (pageSize: PageSize) => void;
  handleSort: (sortInfo: CreditSortableColumn) => void;
  sortDirection?: SortOrder;
  sortProperty?: CreditSortableColumnKeys;
}

export interface CreditListProps {
  creditList: Credit[];
  pageSize: PageSize;
  totalPage: number;
  totalCredits: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: PageSize) => void;
  onSort: (sortInfo: CreditSortableColumn) => void;
  sortProperty?: string;
  sortDirection?: "asc" | "desc";
}

export interface CreditAddress {
  id?: number;
  name?: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface Credit {
  creditNo: string;
  type: CreditType;
  shipTo: CreditAddress;
  billTo: CreditAddress;
  total: number;
  currency: string;
  creditDate: string;
  status: CreditStatus;
  poNumber: string;
  invoiceNo: string;
  orderLineItems: InvoiceItem[];
  notes: string[];
}

export interface CreditList {
  credits: Credit[];
  pagination: {
    pageNumber: number;
    pageSize: number;
    total: number;
  };
  sorting: {
    sortBy: CreditSortableColumnKeys;
    sortDirection: SortOrder;
  };
}
